import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { IdleDialogComponent } from '@shared/components/idle-dialog/idle-dialog.component';
import { ThemeCustomizerComponent } from '@shared/components/theme-customizer/theme-customizer.component';
import { IdleManagerService, AuthService, ThemeService } from '@core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent, IdleDialogComponent, ThemeCustomizerComponent],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly idleSubscription?: Subscription;
  /** Ensures theme service boots and applies saved / default (purple) theme. */
  private readonly themeService = inject(ThemeService);

  constructor(
    private readonly idleManagerService: IdleManagerService,
    private readonly authService: AuthService
  ) {}

  ngOnInit() {
    // Initialize idle manager service - it will handle route changes automatically
    if (this.isUserLoggedIn()) {
      this.idleManagerService.startIdleService();
    }
  }

  ngOnDestroy() {
    if (this.idleSubscription) {
      this.idleSubscription.unsubscribe();
    }
    this.idleManagerService.stopIdleService();
  }

  onStayLoggedIn(): void {
    // Reset the idle timer when user chooses to stay logged in
    this.idleManagerService.resetIdleTimer();
  }

  onLogout(): void {
    // Handle any additional logout logic here
    // The idle service will handle the actual logout process
  }

  private isUserLoggedIn(): boolean {
    return this.authService.isAuthenticated();
  }
}
